// Decorative, non-persisted example data for the four mockup placeholders.
// Referenced by nothing other than placeholder presentation — not a Campaign
// payload field, not a File relationship, and not consumed by the later API
// integration. There is no backend slot concept: no Campaign File is ever
// assigned, indexed, matched, or fallback-mapped into a placeholder.

export type CampaignMockupSlotId = 'story' | 'feed' | 'reel' | 'print'

export interface CampaignMockupSlotDecor {
	readonly slot: CampaignMockupSlotId
	readonly label: string
	readonly aspectRatioLabel: string
	/** Decorative caption only — never sourced from a Campaign File. */
	readonly exampleCaption: string
}

export const CAMPAIGN_MOCKUP_SLOT_DECOR: readonly CampaignMockupSlotDecor[] = [
	{ slot: 'story', label: 'Story', aspectRatioLabel: '9:16', exampleCaption: 'Story-format placeholder mood board' },
	{ slot: 'feed', label: 'Feed', aspectRatioLabel: '1:1', exampleCaption: 'Feed-format placeholder mood board' },
	{ slot: 'reel', label: 'Reel', aspectRatioLabel: '9:16', exampleCaption: 'Reel-format placeholder mood board' },
	{ slot: 'print', label: 'Print', aspectRatioLabel: 'A4', exampleCaption: 'Print-format placeholder mood board' },
]
